import { useEffect, useState } from "react";
import { MessageSquare, Star, Store } from "lucide-react";
import { PhotoStrip } from "@/components/ReviewPhotos";
import { Avatar } from "@/components/Avatar";
import { CommentThread } from "@/components/CommentThread";
import { api } from "@/lib/api";

export function VendorReviews() {
  const [reviews, setReviews] = useState(null);
  useEffect(() => { api.get("/vendor/reviews").then((r) => setReviews(r.data)).catch(() => setReviews([])); }, []);
  useEffect(() => {
    const el = reviews && window.location.hash && document.getElementById(window.location.hash.slice(1));
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [reviews]);

  return (
    <section data-testid="vendor-reviews" className="mt-12">
      <h2 className="text-2xl font-bold flex items-center gap-2 mb-5"><MessageSquare className="h-5 w-5 text-[#FFB800]" /> Traveler reviews</h2>
      {reviews?.length === 0 && <p data-testid="vendor-reviews-empty" className="text-sm text-slate-500 rounded-2xl border border-dashed border-[#26334D] p-8 text-center">No reviews yet. They'll show up here once travelers review your business.</p>}
      <div className="space-y-3">
        {reviews?.map((r) => (
          <div key={r.id} id={`review-${r.id}`} data-testid={`vendor-review-${r.id}`} className="scroll-mt-24 rounded-2xl bg-[#151C2C] border border-[#26334D] p-4">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div className="flex items-center gap-2">
                <span className="flex">{[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`h-3.5 w-3.5 ${n <= r.rating ? "fill-[#FFB800] text-[#FFB800]" : "text-slate-600"}`} />)}</span>
                <Avatar url={r.author_avatar} name={r.user_name} size="h-7 w-7" /><span className="text-sm font-semibold">{r.user_name}</span>
                <span className="text-xs text-slate-500">on {r.business}</span>
              </div>
              <span className="text-xs text-slate-500">{new Date(r.updated_at).toLocaleDateString()}</span>
            </div>
            {r.text && <p className="text-sm text-slate-300 mt-2">{r.text}</p>}
            <PhotoStrip photos={r.photos} rid={r.id} />
            {r.reply?.text && <p className="mt-2 pl-3 border-l-2 border-[#FFB800] text-sm text-slate-300"><span className="text-[#FFB800] text-xs font-semibold flex items-center gap-1"><Store className="h-3 w-3" /> Your earlier reply</span>{r.reply.text}</p>}
            <CommentThread kind="review" target={r.id} count={r.comment_count} defaultOpen tid={`vendor-${r.id}`} />
          </div>
        ))}
      </div>
    </section>
  );
}
